// extracted by mini-css-extract-plugin
module.exports = {"root":"nKP9n","inner":"_1ivT-","content":"bW25P","title":"_5e84C","subtitle":"_3YY56","button":"_3gyw3","item":"z7MPC","items":"_3-j4y"};